<template>
    <div class="customer-details-wrap">
        <div class="customer-details">
            <a href="javascript: void(0)" class="close" @click="closeCustomerDetails"></a> 
            <div v-if="isReturning" class="existing-customer">
                <div class="d-flex align-items-center">
                    <div class="first-col">
                        <h3 class="customer-name">{{ customerName }}</h3>
                        <p>Customer #: {{ discountCustomer.customer_number }}</p>
                    </div>
                    <div>
                        <p>{{ discountCustomer.email }}</p>
                        <p>
                            <span v-if="discountCustomer.sms">{{ discountCustomer.phone }}</span>
                            <span v-else>&nbsp;</span>
                        </p>
                    </div>
                </div>
            </div>
            <div v-else class="temp-customer">
                <h2>Temporary customer</h2>
            </div>
        </div>
        <div class="activity-box">
            <div class="d-grid">
                <customerActivity 
                    ref="bj"
                    :activity="'Bungy'" 
                    :activityCode="'bj'" 
                    :position="'left'" 
                    @close-other-activity="closeAllActivityForm"
                ></customerActivity>
                <customerActivity 
                    ref="sj"
                    :activity="'Skyjump'" 
                    :activityCode="'sj'" 
                    :position="'left'" 
                    @close-other-activity="closeAllActivityForm"
                ></customerActivity>
                <customerActivity 
                    ref="sw"
                    :activity="'Skywalk'" 
                    :activityCode="'sw'" 
                    :position="'left'" 
                    @close-other-activity="closeAllActivityForm"
                ></customerActivity>
                <customerActivity 
                    ref="tc"
                    :activity="'Tower climb'" 
                    :activityCode="'tc'" 
                    :position="'right'" 
                    @close-other-activity="closeAllActivityForm"
                ></customerActivity>
            </div>
        </div>
    </div>
</template>

<script>

    import customerActivity from "./DiscountCustomerActivity.vue";
    import {mapActions, mapState} from 'vuex';

    export default {
        props: ['isReturning'],
        data() {
            return {
                show_activity_form: false
            }
        },
        computed: {
            ...mapState([
                'discountCustomer',
            ]),
            customerName() {
                if(!this.discountCustomer.firstname && !this.discountCustomer.lastname) {
                    return this.discountCustomer.chinese_name;
                }
                
                return this.discountCustomer.firstname + " " + this.discountCustomer.lastname;
            },
        },
        components: {
            customerActivity
        },
        methods: {
            closeCustomerDetails() {
                this.$emit('set-button-toggle', false);
            },
            closeAllActivityForm() {
                this.$refs.bj.closeActivityForm();
                this.$refs.sj.closeActivityForm();
                this.$refs.sw.closeActivityForm();
                this.$refs.tc.closeActivityForm();
            }
        }
    }
</script>